import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=b5b5cd20&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"
import style0 from "./Offers.vue?vue&type=style&index=0&id=b5b5cd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b5cd20",
  null
  
)

export default component.exports